export const SEND_VERIFICATION = 'SEND_VERIFICATION';
export const SAVE_NEW_VENDOR = 'SAVE_NEW_VENDOR';
export const GET_VERIFICATION = 'GET_VERIFICATION';
export const GET_VERIFICATION_GC = 'GET_VERIFICATION_GC';
export const SET_VERIFICATION = 'SET_VERIFICATION';
export const SEND_AGENT_NOTIFICATION = 'SEND_AGENT_NOTIFICATION';
